import React from "react";
import styled from "styled-components";
import { useTranslation } from "src/hooks";
import {
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  ModalManager,
  Text,
} from "../../../components";

export const ListContainerEl = styled.ul`
  list-style: disc;
  padding-left: 1em;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
  line-height: ${(props) => props.theme.text.lineHeight.normal};
  color: ${(props) => props.theme.colors.text.soft};
`;

export const ListEl = styled.li`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  margin-left: ${(p) => p.theme.dimension.spacing.s}px;
`;

type IGuideModalProps = {
  onClose: () => void;
  show: boolean;
};

export const GuideModal: React.FC<IGuideModalProps> = (props) => {
  const translate = useTranslation();
  const { onClose, show } = props;
  const path = "business_info.physical_business.guide";

  return (
    <>
      <ModalManager onClose={onClose} showModal={show}>
        <Modal fitWidth style={{ height: "auto" }}>
          <ModalContent>
            <Text marginBottomXxl marginTopS fontWeight="demi">
              {translate(`${path}.title`)}
            </Text>
            <ListContainerEl>
              <ListEl>{translate(`${path}.point_1`)}</ListEl>
              <ListEl>{translate(`${path}.point_2`)}</ListEl>
            </ListContainerEl>
          </ModalContent>
          <ModalFooter alignLeft>
            <Button onClick={onClose}>{translate(`${path}.cta`)}</Button>
          </ModalFooter>
        </Modal>
      </ModalManager>
    </>
  );
};
